import { Box } from "../../box";
import { forwardRef } from "react";
import { cssModule, mergeProps, normalizeSize, slot } from "../../shared";
import { useResponsiveValue, useStyleProps } from "../../styling";
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultElement = "span";
export function InnerText(props) {
  const [styleProps] = useStyleProps("text");
  const {
    as = DefaultElement,
    children,
    forwardedRef,
    size,
    ...rest
  } = mergeProps(props, styleProps);
  const sizeValue = useResponsiveValue(size);
  return /*#__PURE__*/_jsx(Box, { ...mergeProps(rest, {
      as,
      className: cssModule("o-ui-text", sizeValue && sizeValue === "inherit" ? "inherit-size" : normalizeSize(sizeValue)),
      ref: forwardedRef
    }),
    children: children
  });
}
InnerText.defaultElement = DefaultElement;
export const Text = slot("text", /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerText, { ...props,
  forwardedRef: ref
})));